export default __webpack_public_path__ + "static/media/img3.2e7bb2b7.jpg";